/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2020-09-10 10:40:09
 *
 *******************************************************/
// @flow
export const LIMIT_SHOW_SURVEY_PER_DAY = 2;

export const TYPEFORM_SURVEY = {
  'filter-trees': {
    enabledFrom: '2020-09-16T00:00:00.000Z',
    enabledTo: '2020-09-27T00:00:00.000Z',
    link: 'https://boostcommerce.typeform.com/to/KwDZlM2l',
    mode: 'drawer_right'
  },
  'filter-settings': {
    enabledFrom: '2020-09-16T00:00:00.000Z',
    enabledTo: '2020-09-27T00:00:00.000Z',
    link: 'https://boostcommerce.typeform.com/to/KwDZlM2l',
    mode: 'drawer_right'
  },
  'instant-search-display': {
    enabledFrom: '2020-09-30T00:00:00.000Z',
    enabledTo: '2020-10-11T00:00:00.000Z',
    link: 'https://boostcommerce.typeform.com/to/xRP9eoTs',
    mode: 'drawer_right'
  },
  'suggestion-dictionary': {
    enabledFrom: '2020-09-30T00:00:00.000Z',
    enabledTo: '2020-10-11T00:00:00.000Z',
    link: 'https://boostcommerce.typeform.com/to/xRP9eoTs',
    mode: 'drawer_right'
  },
  'search-settings': {
    enabledFrom: '2020-09-30T00:00:00.000Z',
    enabledTo: '2020-10-11T00:00:00.000Z',
    link: 'https://boostcommerce.typeform.com/to/xRP9eoTs',
    mode: 'drawer_right'
  },
  synonym: {
    enabledFrom: '2020-09-30T00:00:00.000Z',
    enabledTo: '2020-10-11T00:00:00.000Z',
    link: 'https://boostcommerce.typeform.com/to/xRP9eoTs',
    mode: 'drawer_right'
  },
  'stop-words': {
    enabledFrom: '2020-09-30T00:00:00.000Z',
    enabledTo: '2020-10-11T00:00:00.000Z',
    link: 'https://boostcommerce.typeform.com/to/xRP9eoTs',
    mode: 'drawer_right'
  },
  analytics: {
    enabledFrom: '2020-10-21T00:00:00.000Z',
    enabledTo: '2020-11-02T23:59:59.000Z',
    link: 'https://boostcommerce.typeform.com/to/lNsinVZ9',
    mode: 'drawer_right'
  },
  'product-ranking': {
    enabledFrom: '2020-11-03T00:00:00.000Z',
    enabledTo: '2020-11-16T23:59:59.000Z',
    link: 'https://boostcommerce.typeform.com/to/mDGnqumQ',
    mode: 'drawer_right'
  },
  merchandising: {
    // enabledFrom: '2020-11-17T00:00:00.000Z',
    // enabledTo: '2020-11-30T23:59:59.000Z',
    enabledFrom: '2020-10-28T00:00:00.000Z',
    enabledTo: '2020-10-29T23:59:59.000Z',
    link: 'https://boostcommerce.typeform.com/to/lNsinVZ9',
    mode: 'drawer_right'
  },
  'swatch-settings': {
    enabledFrom: '2021-06-02T00:00:00.000Z',
    enabledTo: '2021-06-08T23:59:59.000Z',
    link: 'https://boostcommerce.typeform.com/to/dd445y6a',
    mode: 'drawer_right'
  },
  feedback: {
    enabledFrom: '',
    enabledTo: '',
    link: 'https://boostcommerce.typeform.com/to/jYhtdouq',
    mode: 'drawer_right'
  },
  beta2023: {
    enabledFrom: '2023-03-23T00:00:00.000Z',
    enabledTo: '2023-04-27T23:59:59.000Z',
    link: 'https://boostcommerce.typeform.com/to/tXXnXnln',
    mode: ''
  },
  luckyDraw: {
    enabledFrom: '2023-11-11T00:00:00.000Z',
    enabledTo: '2023-11-30T23:59:59.000Z',
    link: 'https://boostcommerce.typeform.com/to/WGbw3oYz',
    mode: ''
  },
  bfcm23Survey: {
    enabledFrom: '2023-12-08T00:00:00.000Z',
    enabledTo: '2023-12-14T23:59:59.000Z',
    link: 'https://boostcommerce.typeform.com/to/QDkUX2Fb',
    mode: ''
  },
  germanyTestSearchEngine: {
    enabledFrom: '',
    enabledTo: '',
    link: 'https://boostcommerce.typeform.com/to/cGnLYr7q',
    mode: ''
  },
  personalizationCampaign: {
    enabledFrom: '',
    enabledTo: '',
    link: 'https://boostcommerce.typeform.com/personalize-60',
    mode: ''
  }
};
